import { render, staticRenderFns } from "./ComponentFieldsBtn.vue?vue&type=template&id=6df73a80&scoped=true"
import script from "./ComponentFieldsBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentFieldsBtn.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ComponentFieldsBtn.vue?vue&type=style&index=0&id=6df73a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df73a80",
  null
  
)

export default component.exports